'use strict';

/**
 * Style options for leaflet layers
 */

var _ = require('lodash');

var POLYGON_DEFAULTS = {
  weight: 7,
  fill: true,
  fillOpacity: 0.3,
  lineCap: 'square',
  lineJoin: 'square',
  opacity: 0.7,
};

var Styles = {

  // polygon (area) specific styles
  polygon: {
    active: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.5,
      opacity: 1
    }),
    default: POLYGON_DEFAULTS,
    dim: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.1,
      opacity: 0.3
    })
  },
};

module.exports = Styles;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/obstacle/lib/LayerStyles.js